/* SCA Candle — tema davranışları (bağımsız, kütüphanesiz). Bölümler data-sca-* ile işaretlenir; tema editöründe
   section yeniden yüklenince shopify:section:load ile tekrar bağlanır. */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad = (n) => String(n).padStart(2, '0');

  /* duyuru: dönen mesajlar */
  function ann(root) {
    $$('[data-sca-rot]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const m = $$('.sca-ann__msg', el); if (m.length < 2) return;
      let i = 0;
      setInterval(() => { m[i].classList.remove('is-on'); i = (i + 1) % m.length; m[i].classList.add('is-on'); }, (+el.dataset.scaRot || 5) * 1000);
    });
  }

  /* geri sayım: data-sca-cd="2026-12-31T23:59:59+03:00" */
  function cd(root) {
    $$('[data-sca-cd]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const end = new Date(el.dataset.scaCd).getTime();
      const f = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      const tick = () => {
        let t = Math.max(0, end - Date.now()) / 1000;
        const d = Math.floor(t / 86400); t -= d * 86400;
        const h = Math.floor(t / 3600); t -= h * 3600;
        const m = Math.floor(t / 60); const s = Math.floor(t - m * 60);
        if (f.d) f.d.textContent = pad(d); if (f.h) f.h.textContent = pad(h); if (f.m) f.m.textContent = pad(m); if (f.s) f.s.textContent = pad(s);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* başlık: hero üstünde şeffaf → kaydırınca dolu; arama paneli; mobil çekmece */
  function header(root) {
    const w = root.querySelector ? root.querySelector('[data-sca-hwrap]') : null;
    if (!w || w._b) return; w._b = 1;
    const over = w.classList.contains('is-over');
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      w.classList.toggle('is-solid', y > (over ? 40 : 160));
      w.classList.toggle('is-up', y < last);
      last = y;
    };
    if (over) {
      document.body.classList.add('sca-has-over');
      const hh = () => document.documentElement.style.setProperty('--sca-hh', w.offsetHeight + 'px');
      hh(); window.addEventListener('resize', hh);
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    const sp = w.querySelector('[data-sca-search]');
    $$('[data-sca-search-open]', w).forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault(); sp.classList.toggle('is-open'); w.classList.add('is-solid');
      if (sp.classList.contains('is-open')) sp.querySelector('input').focus();
    }));
    const dr = document.querySelector('[data-sca-drawer]');
    const open = (v) => { dr.classList.toggle('is-open', v); document.body.style.overflow = v ? 'hidden' : ''; };
    $$('[data-sca-drawer-open]').forEach((b) => b.addEventListener('click', () => open(true)));
    $$('[data-sca-drawer-close]').forEach((b) => b.addEventListener('click', () => open(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { open(false); sp && sp.classList.remove('is-open'); } });
  }

  /* hero slayt */
  function hero(root) {
    $$('[data-sca-hero]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const s = $$('.sca-hero__slide', el), d = $$('.sca-hero__dot', el);
      if (s.length < 2) return;
      const t = (+el.dataset.scaHero || 6) * 1000; let i = 0, tm;
      const go = (n) => {
        s[i].classList.remove('is-on'); d[i] && d[i].classList.remove('is-on');
        i = (n + s.length) % s.length;
        s[i].classList.add('is-on'); if (d[i]) { d[i].classList.remove('is-on'); void d[i].offsetWidth; d[i].classList.add('is-on'); }
        clearTimeout(tm); tm = setTimeout(() => go(i + 1), t);
      };
      el.style.setProperty('--t', t / 1000 + 's');
      d.forEach((b, n) => b.addEventListener('click', () => go(n)));
      tm = setTimeout(() => go(1), t);
    });
  }

  /* karusel okları + ilerleme çubuğu */
  function car(root) {
    $$('[data-sca-car]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const tr = el.querySelector('.sca-car__track'); const bar = el.querySelector('.sca-car__bar i');
      const prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
      const step = () => (tr.firstElementChild ? tr.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 0) : 300);
      const upd = () => {
        const max = tr.scrollWidth - tr.clientWidth;
        if (bar) { const r = tr.clientWidth / tr.scrollWidth; bar.style.width = r * 100 + '%'; bar.style.left = (max ? tr.scrollLeft / max : 0) * (1 - r) * 100 + '%'; }
        if (prev) prev.disabled = tr.scrollLeft < 4; if (next) next.disabled = tr.scrollLeft > max - 4;
      };
      prev && prev.addEventListener('click', () => tr.scrollBy({ left: -step() * 2 }));
      next && next.addEventListener('click', () => tr.scrollBy({ left: step() * 2 }));
      tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  /* sekmeler (ürün karuseli koleksiyon sekmeleri) */
  function tabs(root) {
    $$('[data-sca-tabs]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const b = $$('.sca-tab', el), p = $$('.sca-tabpane', el);
      b.forEach((x, n) => x.addEventListener('click', () => {
        b.forEach((y) => y.classList.remove('is-on')); p.forEach((y) => y.classList.remove('is-on'));
        x.classList.add('is-on'); p[n].classList.add('is-on'); car(p[n]);
        const tr = p[n].querySelector('.sca-car__track'); tr && tr.dispatchEvent(new Event('scroll'));
      }));
    });
  }

  /* kombini keşfet: nokta ↔ liste eşleşmesi */
  function look(root) {
    $$('[data-sca-look]', root).forEach((el) => {
      if (el._b) return; el._b = 1;
      const dots = $$('.sca-dot', el), items = $$('.sca-look__item', el);
      const on = (n) => { dots.forEach((d, i) => d.classList.toggle('is-on', i === n)); items.forEach((d, i) => d.classList.toggle('is-on', i === n)); };
      dots.forEach((d, n) => { d.addEventListener('mouseenter', () => on(n)); d.addEventListener('click', () => { on(n); items[n] && items[n].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }); });
      items.forEach((d, n) => d.addEventListener('mouseenter', () => on(n)));
      on(0);
    });
  }

  /* görünür olunca belir */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  function rv(root) { $$('.sca-rv', root).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in'))); }

  /* WhatsApp: 6 sn sonra kısa ipucu balonu */
  function wa(root) {
    const el = root.querySelector ? root.querySelector('[data-sca-wa]') : null;
    if (!el || el._b) return; el._b = 1;
    let seen = false; try { seen = sessionStorage.getItem('sca-wa') === '1'; } catch (e) { /* gizli pencere */ }
    if (seen) return;
    setTimeout(() => { el.classList.add('is-hint'); setTimeout(() => el.classList.remove('is-hint'), 7000); try { sessionStorage.setItem('sca-wa', '1'); } catch (e) { /* yok */ } }, 6000);
  }

  /* ---------- kart galerisi (10-16) ---------- */
  // masaüstü: fare kartın görsel alanının hangi dilimindeyse o kare; çıkınca 1. kare (kart linki görselin üstünü örttüğü için kart üzerinden ölçülür).
  // mobil: yatay scroll-snap, nokta scroll'dan; görsele dokunma ürüne gider. 2-4. kareler data-sca-srcset ile bekler, ilk etkileşimde yüklenir.
  // Delege ⇒ sayfalama / sekme / editörde yeniden çizilen kartlarda da çalışır.
  const galYukle = (g) => {
    if (g.dataset.scaGalOk) return; g.dataset.scaGalOk = 1;
    $$('img[data-sca-srcset]', g).forEach((im) => { im.srcset = im.dataset.scaSrcset; im.removeAttribute('data-sca-srcset'); });
  };
  const galSec = (g, i) => {
    if (g._i === i) return; g._i = i;
    $$('.sca-gal > img', g).forEach((m, k) => m.classList.toggle('is-on', k === i));
    $$('.sca-gal__dots i', g).forEach((d, k) => d.classList.toggle('is-on', k === i));
  };
  let galSon = null;
  if (matchMedia('(hover: hover)').matches) {
    document.addEventListener('mousemove', (e) => {
      const kart = e.target.closest && e.target.closest('.card-wrapper');
      const g = kart && kart.querySelector('[data-sca-gal]');
      if (galSon && galSon !== g) { galSec(galSon, 0); galSon = null; }
      if (!g) return;
      const r = g.getBoundingClientRect();
      if (e.clientY > r.bottom || e.clientY < r.top) { galSec(g, 0); return; }
      galYukle(g); galSon = g;
      const n = $$('.sca-gal > img', g).length;
      galSec(g, Math.min(n - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * n))));
    }, { passive: true });
    document.addEventListener('mouseleave', () => { if (galSon) { galSec(galSon, 0); galSon = null; } });
  } else {
    document.addEventListener('touchstart', (e) => { const g = e.target.closest && e.target.closest('[data-sca-gal]'); if (g) galYukle(g); }, { passive: true });
    document.addEventListener('scroll', (e) => {
      const t = e.target; if (!t.classList || !t.classList.contains('sca-gal')) return;
      const i = Math.round(t.scrollLeft / t.clientWidth);
      $$('.sca-gal__dots i', t.parentNode).forEach((d, k) => d.classList.toggle('is-on', k === i));
    }, { capture: true, passive: true });
    document.addEventListener('click', (e) => {
      const g = e.target.closest && e.target.closest('[data-sca-gal]'); if (!g) return;
      const a = g.closest('.card-wrapper').querySelector('.card__heading a');
      if (a) location.href = a.href;
    });
  }

  function init(root = document) { ann(root); cd(root); header(root); hero(root); car(root); tabs(root); look(root); rv(root); wa(root); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
